var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ps-container buy-plugin"},[(_vm.loading)?_c('status-message',{attrs:{"message":_vm.statusMessage}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }